import { CardsCatalog } from "./catalog.model";
export const MarvelChampionsCards = CardsCatalog;
